module.exports = __webpack_public_path__ + "img/up-arrow.89a532b5.svg";